import { ChangeDetectionStrategy, Component, DestroyRef, effect, inject, input, model, output, signal, viewChild } from '@angular/core';
import { Sparte } from '@mwe/models';
import { NgbDropdown, NgbDropdownButtonItem, NgbDropdownItem, NgbDropdownMenu, NgbDropdownToggle } from '@ng-bootstrap/ng-bootstrap';
import { NgClass } from '@angular/common';
import { TranslatePipe } from '@ngx-translate/core';
import { TranslateCategoryPipe } from '@mwe/ui/pipes';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { tap } from 'rxjs/operators';

@Component({
  selector: 'mwe-category-dropdown-filter',
  templateUrl: './category-dropdown-filter.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    NgbDropdown,
    NgbDropdownToggle,
    NgbDropdownMenu,
    NgbDropdownButtonItem,
    NgbDropdownItem,
    NgClass,
    TranslatePipe,
    TranslateCategoryPipe,
  ],
})
export class CategoryDropdownFilterComponent {
  readonly categoryOptions = input<Sparte[]>([]);
  readonly selectedCategory = model<Sparte>();
  readonly onSelectedCategory = output<Sparte>();

  readonly isCollapsed = signal<boolean>(true);
  readonly dropdown = viewChild(NgbDropdown);

  destroyRef = inject(DestroyRef);

  constructor() {
    effect(() => {
      this.dropdown()
        ?.openChange?.pipe(
          takeUntilDestroyed(this.destroyRef),
          tap(isOpen => this.isCollapsed.set(!isOpen)),
        )
        .subscribe();
    });
  }

  isFernwaermeTariffClass(sparte: Sparte): boolean {
    return ['HEIZUNG', 'WARMWASSER', 'HEIZUNG_WARMWASSER', 'KALT-/ABWASSER', 'KALT_ABWASSER'].includes(sparte);
  }

  selectCategory(category: Sparte): void {
    this.selectedCategory.set(category);
    this.onSelectedCategory.emit(this.selectedCategory());
  }
}
